var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashActiveHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Trash_Active_-_Hover",
    "data-name": "Trash | Active - Hover",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.543,
    height: 22.797,
    viewBox: "0 0 19.543 22.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    "data-name": "Caminho 434",
    d: "M13.168,20A1.168,1.168,0,0,0,12,21.168V31.924a4.36,4.36,0,0,0,4.36,4.36h7.564a4.36,4.36,0,0,0,4.36-4.36V21.168A1.168,1.168,0,0,0,27.115,20Zm3.717,11.4a.814.814,0,1,1-1.628,0V24.071a.814.814,0,1,1,1.628,0Zm4.071,0a.814.814,0,1,1-1.628,0V24.071a.814.814,0,1,1,1.628,0Zm4.071,0a.814.814,0,1,1-1.628,0V24.071a.814.814,0,1,1,1.628,0Z",
    transform: "translate(-10.37 -13.487)",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    "data-name": "Caminho 435",
    d: "M27.538,7.607a1.274,1.274,0,0,0-1.3-1.164H21.408a.383.383,0,0,1-.383-.383V5.628A1.628,1.628,0,0,0,19.4,4H16.14a1.628,1.628,0,0,0-1.628,1.628V6.06a.383.383,0,0,1-.383.383H9.3A1.274,1.274,0,0,0,8,7.607,1.221,1.221,0,0,0,9.219,8.885h17.1a1.221,1.221,0,0,0,1.221-1.278ZM19.4,6.035a.407.407,0,0,1-.407.407H16.547a.407.407,0,0,1,0-.814h2.443A.407.407,0,0,1,19.4,6.035Z",
    transform: "translate(-7.997 -4)",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashActiveHover);
export default __webpack_public_path__ + "static/media/Trash  Active - Hover.7cd41a23.svg";
export { ForwardRef as ReactComponent };